import { useCallback, useState } from 'react';
import {
  loadUserSettingsPreferences,
  saveUserSettingsPreferences,
} from '../../../utils';

interface UseAIWarningStateReturn {
  showWarning: boolean;
  handleDismissWarning: (checked: boolean) => void;
}

export function useAIWarningState(
  userId: string | undefined
): UseAIWarningStateReturn {
  const [isSessionDismissed, setIsSessionDismissed] = useState(false);

  const preferences = loadUserSettingsPreferences(userId);

  const isPermanentlyDismissed = preferences.aiWarningDismissed || false;

  const showWarning = !isPermanentlyDismissed && !isSessionDismissed;

  const handleDismissWarning = useCallback(
    (checked: boolean) => {
      setIsSessionDismissed(true);

      if (checked && userId) {
        saveUserSettingsPreferences(userId, {
          aiWarningDismissed: true,
        });
      }
    },
    [userId]
  );

  return {
    showWarning,
    handleDismissWarning,
  };
}
